"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PdfInfinite_1 = tslib_1.__importDefault(require("src/components/PdfInfinite"));
const Viewer = (props) => {
    const pdfRef = (0, react_1.useRef)(null);
    const handleScroll = () => {
        if (pdfRef.current && props.setScrolledToBottom) {
            const { scrollTop, scrollHeight, clientHeight } = pdfRef.current;
            const isBottom = scrollTop + clientHeight >= scrollHeight - 10;
            if (isBottom)
                props.setScrolledToBottom(true);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { style: { height: 520, width: '100%', overflowY: 'auto' }, children: (0, jsx_runtime_1.jsx)("div", { className: 'd-flex justify-content-center', children: (0, jsx_runtime_1.jsx)("div", { style: { width: '960px' }, className: 'bg-white', children: (0, jsx_runtime_1.jsx)("div", { className: 'container', style: { height: 500, overflow: 'scroll', overflowX: 'hidden' }, onScroll: handleScroll, ref: pdfRef, children: (0, jsx_runtime_1.jsx)(PdfInfinite_1.default, { pdfFileUrl: props.pdfFileUrl }) }) }) }) }));
};
exports.default = Viewer;
